import React, { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { BsFiletypePdf } from "react-icons/bs";
import { Search } from "lucide-react";
import logo from "../../Assets/Logos/ashok.png";
import img from "../../Assets/Login/profile3.png";
import PortalModal from "../PortalModal";
import axios from "axios";
import { FiMail } from "react-icons/fi";
import { BsFillTelephoneFill } from "react-icons/bs";
import html2pdf from "html2pdf.js";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { useAssets } from "../../Context/AssetsContext";

export default function AadharCard() {
  const { assetsReady, assets } = useAssets();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [aadharNo, setAadharNo] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpField, setShowOtpField] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientId, setClientId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const itemsPerPage = 10;
  const printRef = useRef();
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    fromDate: "",
    toDate: "",
  });
  const [aadharPrices, setAadharPrices] = useState({
    aadhar: 0,
  });
  const [aadharAccess, setAadharAccess] = useState({
    aadhar: false,
  });
  const [filteredHistory, setFilteredHistory] = useState([]);
  const resetForm = () => {
    setName("");
    setAadharNo("");
    setDob("");
    setOtp("");
    setShowOtpField(false);
    setOtpVerified(false);
    setClientId("");
    setError("");
  };
  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/get-document-records?service=aadhaar`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const historyData = response.data.map((item, index) => ({
        date: new Date(item.createdAt).toLocaleString(),
        slNo: `${index + 1}`.padStart(3, "0"),
        aadharNumber: item.idNumber,
        status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        error: item.status === "failed" ? "Verification failed" : "",
        createdAt: new Date(item.createdAt),
      }));

      setHistory(historyData);
      setFilteredHistory(historyData);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch history");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAadhaarAccess();
  }, []);

  // Match Registration access check logic
  const fetchAadhaarAccess = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/access-check`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const access = response.data?.serviceAccess || [];
      const prices = response.data?.servicePrices || {};

      setAadharAccess({
        aadhar: access.includes("aadhaar"),
      });
      setAadharPrices({
        aadhar: prices.aadhaar,
      });
    } catch (e) {
      console.error("Error fetching access data:", e);
      toast.error("Failed to load service access information");
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const updateHistory = (entry) => {
    setHistory((prev) => [...prev, entry]);
  };
  const applyFilters = () => {
    let result = [...history];

    // Apply search filter
    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      result = result.filter(
        (item) =>
          item.aadharNo.toLowerCase().includes(searchTerm) ||
          (item.name && item.name.toLowerCase().includes(searchTerm)),
      );
    }

    // Apply status filter
    if (filters.status) {
      result = result.filter((item) => item.status === filters.status);
    }

    // Apply date range filter
    if (filters.fromDate) {
      const fromDate = new Date(filters.fromDate);
      result = result.filter((item) => new Date(item.dateTime) >= fromDate);
    }

    if (filters.toDate) {
      const toDate = new Date(filters.toDate);
      toDate.setHours(23, 59, 59, 999); // Include entire day
      result = result.filter((item) => new Date(item.dateTime) <= toDate);
    }

    setFilteredHistory(result);
    setCurrentPage(1); // Reset to first page when filters change
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      status: "",
      fromDate: "",
      toDate: "",
    });
    setFilteredHistory([...history]);
  };

  useEffect(() => {
    applyFilters();
  }, [filters]);

  const handleGenerateOTP = () => {
    if (!aadharNo || aadharNo.length !== 12 || !/^\d+$/.test(aadharNo)) {
      toast.error("Invalid Aadhaar number. Must be 12 digits.");
      return;
    }

    // Show confirmation modal instead of making API call directly
    setShowConfirmationModal(true);
  };

  const proceedWithApiCall = async () => {
    if (!aadharNo || aadharNo.length !== 12 || !/^\d+$/.test(aadharNo)) {
      toast.error("Invalid Aadhaar number. Must be 12 digits.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Correct API endpoint for OTP generation
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/services/aadhar/eaadhar-generate-otp`,
        { id_number: aadharNo },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      if (response.data.success && response.data.data?.client_id) {
        setClientId(response.data.data.client_id);
        setShowOtpField(true);
        setError("");
      } else {
        setError(response.data.message || "Failed to generate OTP");
      }
    } catch (err) {
      console.error("Error generating OTP:", err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "Failed to generate OTP. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp || otp.length !== 6 || !/^\d+$/.test(otp)) {
      setError("OTP must be 6 digits");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Correct API endpoint for OTP verification
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/services/aadhar/eaadhar-submit-otp`,
        { client_id: clientId, otp },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      // Simulate API delay
      await new Promise((resolve) => setTimeout(resolve, 500));

      if (response.data.success && response.data.data?.aadhaar_pdf) {
        const aadhaarData = response.data.data;
        setOtpVerified(true);

        const extractedName = `User ${aadhaarData.aadhaar_number.slice(0, 4)}`;

        setSelectedCard({
          name: extractedName,
          aadharNumber: aadhaarData.aadhaar_number,
          gender: "MALE",
          father: "Father's Name",
          address: "Sample Address, City, State - 123456",
          vid: `1234-5678-${Math.floor(1000 + Math.random() * 9000)}`,
          photoUrl: img,
          pdfUrl: aadhaarData.aadhaar_pdf,
        });

        updateHistory({
          slNo: `${history.length + 1}`.padStart(3, "0"),
          name: extractedName,
          aadharNo: aadhaarData.aadhaar_number,
          status: "Success",
          dateTime: new Date().toLocaleString(),
          pdfUrl: aadhaarData.aadhaar_pdf,
        });
        setError("");
      } else {
        setError(response.data.message || "OTP verification failed");
        updateHistory({
          slNo: `${history.length + 1}`.padStart(3, "0"),
          name: "",
          aadharNo: aadharNo,
          status: "Failed",
          dateTime: new Date().toLocaleString(),
        });
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      setError(
        err.response?.data?.message ||
          err.message ||
          "Failed to verify OTP. Please try again.",
      );
      updateHistory({
        slNo: `${history.length + 1}`.padStart(3, "0"),
        name: "",
        aadharNo: aadharNo,
        status: "Failed",
        dateTime: new Date().toLocaleString(),
      });
    } finally {
      setLoading(false);
      resetForm();
    }
  };
  const handleDownloadPDF = async (pdfUrl) => {
    if (!assetsReady) {
      toast.warning("Please wait, assets are still preloading...");
      return;
    }
    if (!pdfUrl) return;

    try {
      const response = await fetch(pdfUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Aadhaar_${selectedCard?.aadharNumber || "Card"}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error downloading PDF:", err);
      setError("Failed to download PDF. Please try again.");
    }
  };

  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const currentData = filteredHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  // Pricing logic
  const defaultPrices = {
    aadhaar: 10,
    pan: 10,
    smartrc: 25,
    voterId: 10,
    drivingLicense: 10,
    parivaanrc: 10,
    digilockerrc: 10,
  };
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");
  const aadhaarPrice =
    currentUser?.servicePrices?.aadhaar ?? defaultPrices.aadhaar;

  return (
    <div className="py-4 w-full">
      <div className="bg-blue-100 p-2 mb-4">
        <h2 className="text-center text-xl font-semibold text-blue-700">
          Aadhar Card
        </h2>
      </div>

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <div className="py-4">
        <div className="flex flex-col md:flex-row gap-4 mb-4">
          <input
            type="text"
            placeholder="Enter Aadhar Number"
            value={aadharNo}
            onChange={(e) => setAadharNo(e.target.value)}
            className="flex-1 px-4 py-2 border rounded"
            maxLength={12}
          />
          {showOtpField && (
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="flex-1 px-4 py-2 border rounded"
              maxLength={6}
            />
          )}
        </div>

        <div className="flex flex-col md:flex-row items-center gap-4">
          {!showOtpField ? (
            <button
              onClick={handleGenerateOTP}
              disabled={loading}
              className={`bg-green-700 text-white px-6 py-2 rounded disabled:opacity-50  ${
                !aadharAccess.aadhar
                  ? "opacity-50 cursor-not-allowed"
                  : "cursor-pointer"
              }`}
            >
              {loading ? "SENDING OTP..." : "SEND OTP"}
            </button>
          ) : (
            <button
              onClick={handleVerifyOTP}
              disabled={loading}
              className="bg-blue-600 text-white px-6 py-2 rounded disabled:opacity-50"
            >
              {loading ? "VERIFYING..." : "VERIFY OTP"}
            </button>
          )}
          <span className="text-red-600">₹{aadhaarPrice}</span>
        </div>
      </div>

      <div className="bg-white p-4 shadow-md rounded-lg mb-4">
        <h3 className="text-lg font-semibold mb-4">
          Aadhar Card Download History
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
          {/* Search Filter */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Search Aadhaar/Name
            </label>
            <input
              type="text"
              placeholder="Search..."
              value={filters.search}
              onChange={(e) =>
                setFilters({ ...filters, search: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>

          {/* Status Filter */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Status
            </label>
            <select
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2"
            >
              <option value="">All Status</option>
              <option value="Success">Success</option>
              <option value="Failed">Failed</option>
            </select>
          </div>

          {/* Date Range Filters */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              From Date
            </label>
            <input
              type="date"
              value={filters.fromDate}
              onChange={(e) =>
                setFilters({ ...filters, fromDate: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              To Date
            </label>
            <input
              type="date"
              value={filters.toDate}
              onChange={(e) =>
                setFilters({ ...filters, toDate: e.target.value })
              }
              className="w-full border border-gray-300 rounded px-3 py-2"
            />
          </div>
        </div>

        {/* Filter Buttons */}
        <div className="flex justify-end gap-2">
          <button
            onClick={clearFilters}
            className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
          >
            Clear Filters
          </button>
          <button
            onClick={applyFilters}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Apply Filters
          </button>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg overflow-x-auto">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="px-4 py-2">Sl No</th>
              <th className="px-4 py-2">Date & Time</th>
              <th className="px-4 py-2">Aadhaar No</th>
              <th className="px-4 py-2">Name</th>
              <th className="px-4 py-2">DOB</th>
              <th className="px-4 py-2">Status</th>
              <th className="px-4 py-2">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((item, idx) => (
                <tr key={idx} className="border-t hover:bg-gray-50">
                  <td className="px-4 py-2">
                    {(currentPage - 1) * itemsPerPage + idx + 1}
                  </td>
                  <td className="px-4 py-2">{item.dateTime}</td>
                  <td className="px-4 py-2 font-mono">{item.aadharNo}</td>
                  <td className="px-4 py-2">{item.name}</td>
                  <td className="px-4 py-2">{item.dob}</td>
                  <td className="px-4 py-2">
                    <span
                      className={`px-2 py-1 rounded text-white text-xs ${
                        item.status === "Success"
                          ? "bg-green-500"
                          : "bg-red-500"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td className="px-4 py-2">
                    {item.pdfUrl && (
                      <button
                        onClick={() => handleDownloadPDF(item.pdfUrl)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <BsFiletypePdf className="inline" />
                      </button>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="px-4 py-4 text-center text-gray-500">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="flex justify-between items-center py-4 text-sm">
          <span>
            Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
            {Math.min(currentPage * itemsPerPage, history.length)} of{" "}
            {history.length} entries
          </span>
          <div className="flex space-x-2 pt-2">
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              Prev
            </button>

            {(() => {
              const buttonsToShow = 2;
              let start = Math.max(
                1,
                currentPage - Math.floor(buttonsToShow / 2),
              );
              let end = start + buttonsToShow - 1;

              if (end > totalPages) {
                end = totalPages;
                start = Math.max(1, end - buttonsToShow + 1);
              }

              const pages = [];
              for (let i = start; i <= end; i++) {
                pages.push(
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i)}
                    className={`px-3 py-1 rounded ${
                      i === currentPage
                        ? "bg-blue-500 text-white"
                        : "bg-gray-200 hover:bg-gray-300"
                    }`}
                  >
                    {i}
                  </button>,
                );
              }
              return pages;
            })()}

            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
              className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </div>
      )}
      {showConfirmationModal && (
        <PortalModal>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <h3 className="text-lg font-semibold mb-4">Confirm Payment</h3>
              <p className="mb-4">
                This Aadhaar verification will cost you{" "}
                <span className="text-red-600"> ₹{aadhaarPrice} </span>. Do you
                want to proceed?
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setShowConfirmationModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowConfirmationModal(false);
                    proceedWithApiCall();
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Confirm & Pay
                </button>
              </div>
            </div>
          </div>
        </PortalModal>
      )}
      {selectedCard && (
        <PortalModal>
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white border rounded-md shadow-md p-3 text-[12px] font-sans text-black overflow-hidden box-border">
              <div
                ref={printRef}
                className="flex flex-wrap justify-center items-center gap-4 px-2"
              >
                <div className="border relative w-[24.8rem] h-[15.8rem] border-black shadow p-1 box-border overflow-hidden">
                  <div className="flex justify-between items-center">
                    <img
                      src={assets.ashok || logo}
                      alt="India Emblem"
                      className="w-10 h-10"
                    />
                    <div className="text-center text-xs leading-tight">
                      <div className="text-orange-600 font-bold">
                        भारत सरकार
                      </div>
                      <div className="text-green-700 font-bold">
                        Government of India
                      </div>
                    </div>
                    <img
                      src={assets.aadharLogo || logo}
                      alt="Aadhaar Logo"
                      className="w-12 h-12"
                    />
                  </div>

                  <div className="flex justify-between mt-2">
                    <div className="w-[80px] h-[95px] bg-gray-200 border overflow-hidden">
                      <img
                        src={selectedCard.photoUrl}
                        alt="User"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="flex-1 text-[11px] ml-3 leading-tight overflow-hidden">
                      <p>Name: {selectedCard.name}</p>
                      <p>Father Name: {selectedCard.father}</p>
                      <p>DOB: {selectedCard.dob}</p>
                      <p>
                        {selectedCard.gender === "MALE"
                          ? "पुरुष / MALE"
                          : "महिला / FEMALE"}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-between items-center mt-2 relative">
                    <div className="text-center w-full font-semibold text-base tracking-widest">
                      {selectedCard.aadharNumber.replace(/-/g, " ")}
                    </div>
                    <div className="absolute right-4">
                      <QRCodeCanvas
                        value={selectedCard.aadharNumber}
                        size={83}
                      />
                    </div>
                  </div>

                  <div className="absolute bottom-0 left-0 w-full border-t-2 text-[1.2rem] border-red-600 text-center bg-white">
                    <span className="text-red-600 font-bold">आधार</span> - आम
                    आदमी का अधिकार
                  </div>
                </div>

                <div className="border w-[24.8rem] h-[15.8rem] border-black shadow box-border overflow-hidden">
                  <div className="flex items-center p-2">
                    <img
                      src={assets.aadharLogo || logo}
                      alt="Aadhaar Logo"
                      className="w-16 h-16"
                    />
                    <div className="text-[1rem] leading-tight ml-2">
                      <div className="text-orange-600 font-bold">
                        भारत सरकार
                      </div>
                      <div className="text-green-700 font-bold">
                        Unique Identification Authority of India
                      </div>
                    </div>
                  </div>

                  <div className="text-[11px] flex justify-between my-2 px-4 leading-tight">
                    <div>
                      <span className="font-bold">Address:</span>
                      <br />
                      {selectedCard.address}
                    </div>
                    <div>
                      <QRCodeCanvas
                        value={selectedCard.aadharNumber}
                        size={83}
                      />
                    </div>
                  </div>

                  <div className="text-center font-semibold text-base tracking-widest">
                    {selectedCard.aadharNumber.replace(/-/g, " ")}
                  </div>
                  <div className="mt-2 text-center text-[10px] border-t-2 border-red-500 pt-1">
                    <div className="flex justify-between items-center px-4">
                      <div className="flex flex-col items-center">
                        <BsFillTelephoneFill size={14} />
                        <span>1947</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <FiMail size={14} />
                        <span>help@uidai.gov.in</span>
                      </div>
                      <div className="flex flex-col items-center">
                        <span className="border px-[0.2rem] bg-black text-white">
                          WWW
                        </span>
                        <span>www.uidai.gov.in</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 flex justify-between gap-4">
                <button
                  onClick={() => handleDownloadPDF(selectedCard.pdfUrl)}
                  disabled={!assetsReady}
                  className={`px-4 py-1 rounded text-white ${
                    !assetsReady
                      ? "bg-green-400 cursor-not-allowed"
                      : "bg-green-600 hover:bg-green-700"
                  }`}
                >
                  {!assetsReady ? "Loading..." : "Download"}
                </button>
                <button
                  onClick={() => setSelectedCard(null)}
                  className="bg-gray-300 text-black px-4 py-1 rounded hover:bg-gray-400"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </PortalModal>
      )}
    </div>
  );
}
